import React, { useState, useEffect } from 'react';
import './App.css';
import Nav from './components/Nav';
import Hero from './components/Hero';
import Capabilities from './components/Capabilities';
import Industries from './components/Industries';
import Work from './components/Work';
import Clients from './components/Clients';
import Process from './components/Process';
import Stack from './components/Stack';
import Team from './components/Team';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function App() {
  const [navTheme, setNavTheme] = useState('dark');

  useEffect(() => {
    const handleScroll = () => {
      const ivoryElements = document.querySelectorAll('.section--ivory');
      const navHeight = 60;
      let onIvory = false;

      ivoryElements.forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.top <= navHeight && rect.bottom >= navHeight) onIvory = true;
      });

      setNavTheme(onIvory ? 'light' : 'dark');
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="app">
      <Nav theme={navTheme} />
      <Hero />
      <hr className="rule" />
      <Clients />
      <Work />
      <Process />
      <Stack />
      <Industries />
      <Team />
      <Contact />
      <Footer />
    </div>
  );
}
